// export const BASEURL = "http://localhost:4000";
export const BASEURL = "https://api.fiscall.finance";
